/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { QuestionConflictsControllerFindOneQueryResponse, QuestionConflictsControllerFindOnePathParams, QuestionConflictsControllerFindOneQueryParams, QuestionConflictsControllerFindOne400, QuestionConflictsControllerFindOne401, QuestionConflictsControllerFindOne403, QuestionConflictsControllerFindOne404 } from "../../models/checklistsController/QuestionConflictsControllerFindOne";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { questionConflictsControllerFindOne } from "../../clients/checklistsService/questionConflictsControllerFindOne";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const questionConflictsControllerFindOneQueryKey = (id: QuestionConflictsControllerFindOnePathParams["id"], params: QuestionConflictsControllerFindOneQueryParams = {}) => [{
  url: '/api/v1/checklist-question-conflicts/:id',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type QuestionConflictsControllerFindOneQueryKey = ReturnType<typeof questionConflictsControllerFindOneQueryKey>;
export function questionConflictsControllerFindOneQueryOptions(id: QuestionConflictsControllerFindOnePathParams["id"], params?: QuestionConflictsControllerFindOneQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = questionConflictsControllerFindOneQueryKey(id, params);
  return queryOptions<QuestionConflictsControllerFindOneQueryResponse, ResponseErrorConfig<QuestionConflictsControllerFindOne400 | QuestionConflictsControllerFindOne401 | QuestionConflictsControllerFindOne403 | QuestionConflictsControllerFindOne404>, QuestionConflictsControllerFindOneQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return questionConflictsControllerFindOne(id, params, config);
    }
  });
}

/**
 * @summary Get a specific question conflict by ID
 * {@link /api/v1/checklist-question-conflicts/:id}
 */
export function useQuestionConflictsControllerFindOne<TData = QuestionConflictsControllerFindOneQueryResponse, TQueryData = QuestionConflictsControllerFindOneQueryResponse, TQueryKey extends QueryKey = QuestionConflictsControllerFindOneQueryKey>(id: QuestionConflictsControllerFindOnePathParams["id"], params?: QuestionConflictsControllerFindOneQueryParams, options: {
  query?: Partial<QueryObserverOptions<QuestionConflictsControllerFindOneQueryResponse, ResponseErrorConfig<QuestionConflictsControllerFindOne400 | QuestionConflictsControllerFindOne401 | QuestionConflictsControllerFindOne403 | QuestionConflictsControllerFindOne404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? questionConflictsControllerFindOneQueryKey(id, params);
  const query = useQuery({
    ...questionConflictsControllerFindOneQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<QuestionConflictsControllerFindOne400 | QuestionConflictsControllerFindOne401 | QuestionConflictsControllerFindOne403 | QuestionConflictsControllerFindOne404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}